import { Spin } from 'antd'
import React from 'react'

const Spiner = () => {
    return (
        <div className='flex_center' style={{ width: '100%', height: '100%' }} >
            <Spin tip="Loading" size="large" />
        </div>
    )
}

export default Spiner